import React, { useEffect, useState } from "react";
import BriefingTable from "../subcomponents/table";
import { SelectField } from "../subcomponents/fields";
import { fetchRows } from "../helpers";
import { CRUDRow } from "../helpers";
import Actions from "../subcomponents/actions";  // Fixed typo (Actoins -> Actions)
import HistoryViewer from "../subcomponents/historyViewer";
import { useSelector } from "react-redux";
import { TextField } from "components/DriverReservations/subcomponents/fields";

const RadicalRadar = () => {
    const [radicalRadars, setRadicalRadars] = useState([]);
    const briefing = useSelector((state) => state.briefing.line);
    const startDate = useSelector((state) => state.archiveSearch.startDate);
    const endDate = useSelector((state) => state.archiveSearch.endDate);
    const searchTerm = useSelector((state) => state.archiveSearch.searchTerm);
    
    const requestPayload = {
        "startDate": startDate,
        "endDate": endDate,
        "searchTerm": searchTerm
    }

    const DataURL = "admin/briefing/get_radical_radars";
    const RowURL = "admin/briefing/radical_radar_row";

    useEffect(() => {
        (async () => {
            const data = await fetchRows(DataURL, briefing, requestPayload);
            setRadicalRadars(data);
        })();
    }, [startDate, endDate, searchTerm, briefing]);

    // Function to create a new row and refresh the table
    const CRUDHotboardRow = async (action = "create", rowID = null) => {
        await CRUDRow(RowURL, action, rowID);
        // Re-fetch data after modifying the row
        const data = await fetchRows(DataURL);
        setRadicalRadars(data);
    };

    const threatsList = [
        "DOT Week",
        "Election Cities/Visits",
        "Holiday CAN",
        "Holiday MX",
        "Holiday US",
        "Huddle",
        "Natural Disasters",
        "Other",
        "Reefer Season",
        "Riots/Strikes",
        "Weather"
    ];

    const headers = [
        "ID",
        "Event",
        "Notes",
        "Act.",
    ];

    const renderRow = (row) => (
        <tr key={row.id}>
            <td className="row-id-cell">
                <div className="row-id-div">
                    {row.id}
                </div>
            </td>
            <td style={{ width: "15%" }}>
                <SelectField field={row.note_type}>
                    {threatsList.map((stage, index) => (
                        <option key={index}>{stage}</option>
                    ))}
                </SelectField>
            </td>
            <td>
                <TextField field={row.notes} maxLength={null} trackShift={true}/>
            </td>
            <td className="actions-cell">
                <Actions
                    onDelete={() => CRUDHotboardRow("delete", row.id)} // Wrap in a function
                    onArchive={() => CRUDHotboardRow("archive", row.id)} // Wrap in a function
                />
            </td>
        </tr>
    );

    if (briefing === "Old Briefings" && !radicalRadars.length) {
        return null
    }

    return (
        <>
            <div className="table-header">
                <h2>
                    Radical Radar
                </h2>
                <HistoryViewer
                    url={DataURL}
                />
            </div>
            <BriefingTable
                headers={headers}
                rows={radicalRadars}
                renderRow={renderRow}
                createRow={CRUDHotboardRow}
            />
        </>
    );
};

export default RadicalRadar;
